var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-swiper',_vm._b({staticClass:"SliderRow",attrs:{"disable-on-desktop":"","loop":false}},'base-swiper',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }